import React, { Fragment, memo, createRef } from "react";
import isFunction from "lodash/isFunction";
import "../assets/custom/css/choices.css";
import { Form } from "react-bootstrap";

const ChoicesJs = memo((props) => {
  const single = createRef();
  const isMultiple = props.select === "multi" ? true : false;
  const random = () => {
    return Math.floor(Math.random() * 1000) + 1;
  };

  return (
    <Fragment>
      <Form.Select
        ref={single}
        id={random()}
        name={props.name}
        value={props.value}
        className={props.className}
        onChange={(e) =>
          isFunction(props.onChange) ? props.onChange(e) : e.preventDefault()
        }
        multiple={isMultiple}
      >
        <option value={""}>-- Select Option--</option>
        {props.options.map((item, index) => (
          <option key={index} value={item.value}>
            {item.label}
          </option>
        ))}
      </Form.Select>
    </Fragment>
  );
});
ChoicesJs.displayName = "ChoicesJs";
export default React.memo(ChoicesJs);
